import axios from 'axios'

export const fetchSupplierPaymentDays = () => {
  return axios
    .get(`/authenticated/tenant-owner/supplier-payment-days`)
    .then((resp) => resp.data)
}

export const fetchSupplierTradingTermsRules = () => {
  return axios
    .get(`/authenticated/tenant-owner/supplier-trading-terms-rules`)
    .then((resp) => resp.data)
}
